const TEN_MINUTES = 10 * 60 * 1000;

const ERR_NOT_INITIALIZED = 'ClerkTokenSingleton is not initialized';
const ERR_ALREADY_INITIALIZED = 'ClerkTokenSingleton is already initialized';

export class ClerkTokenSingleton {
  _initialized = false;

  _token = '';

  static I = new ClerkTokenSingleton();

  async init(_unused = null, initialToken = '') {
    if (this._initialized) {
      throw new Error(ERR_ALREADY_INITIALIZED);
    }

    this._initialized = true;

    if (initialToken) {
      this._token = initialToken;
    } else {
      await this._fetchToken();
    }
    setInterval(async () => {
      try {
        await this._fetchToken();
      } catch (e) {
        console.error(e);
      }
    }, TEN_MINUTES);
  }

  _fetchToken = async () => {
    const clerk = window.Clerk;
    if (!clerk || !clerk.session) {
      this._token = '';
      throw new Error(ERR_NOT_INITIALIZED);
    }
    // Get a fresh JWT from the Clerk session
    this._token = await clerk.session.getToken({});
    if (!this._token) {
      throw new Error(ERR_NOT_INITIALIZED);
    }
  };
}
